module.exports = __webpack_public_path__ + "img/campaign_small.236fe80b.png";